import { FC } from 'react';
import { CheckGroup } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';
import { FieldError } from 'react-hook-form';

import { Termostatstyring } from '../../../../../utils/registerEnums';

import { CollapseCheckbox } from './collapseCheckbox';
import { TermostatstyringRadio } from './termostatstyringRadio';

interface Props {
  onChange: (field: 'radiator' | 'gulvvarme', value?: Termostatstyring) => void;
  error?: FieldError;
  value?: { gulvvarme?: Termostatstyring; radiator?: Termostatstyring };
  labelKey?: string;
  informationKey?: string;
}

export const Fordelingssystem: FC<Props> = ({ onChange, value, error, labelKey, informationKey }) => {
  const { t } = useTranslation();
  const helperProps = informationKey
    ? {
        'aria-label': t('readFieldInformation'),
        children: t(informationKey)
      }
    : undefined;

  return (
    <CheckGroup
      label={labelKey && t(labelKey)}
      error={!!error}
      helperText={error?.message}
      HelperBoxProps={helperProps}
    >
      <CollapseCheckbox
        labelKey="register.tekniskUtstyr.vannbarenGulvvarme.label"
        error={!!error}
        checked={!!value?.gulvvarme}
        onChange={() => {
          const updatedValue = !value?.gulvvarme ? Termostatstyring.Ukjent : undefined;
          onChange('gulvvarme', updatedValue);
        }}
      >
        <TermostatstyringRadio
          value={value?.gulvvarme}
          labelKey="register.tekniskUtstyr.vannbarenGulvvarme.label"
          informationKey="register.termostatstyring.gulvvarme.information"
          onChange={(v) => onChange('gulvvarme', v as Termostatstyring)}
        />
      </CollapseCheckbox>
      <CollapseCheckbox
        labelKey="register.tekniskUtstyr.radiator.label"
        checked={!!value?.radiator}
        error={!!error}
        onChange={() => {
          const updatedValue = !value?.radiator ? Termostatstyring.Ukjent : undefined;
          onChange('radiator', updatedValue);
        }}
      >
        <TermostatstyringRadio
          value={value?.radiator}
          labelKey="register.termostatstyring.radiator.label"
          informationKey="register.termostatstyring.radiator.information"
          onChange={(v) => onChange('radiator', v as Termostatstyring)}
        />
      </CollapseCheckbox>
    </CheckGroup>
  );
};
